import { dateTimeOf } from "@repo/helpers";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@repo/ui";

import type { ApplicationSetting, SettingEnumOption } from "../../../models";

import { ValueText } from "./valueText";

interface Props {
	name: string;
	/** The row already saved for the name and segment */
	existing: ApplicationSetting;
	/** The value about to replace it */
	value: string;
	/** For an Enum setting, its definition's options, so both values show their labels */
	enumOptions?: SettingEnumOption[] | null;
	onCancel: () => void;
	onOverwrite: () => void;
}

/** Asks before replacing the row that already exists for a setting and segment */
export function OverwriteDialog({ name, existing, value, enumOptions, onCancel, onOverwrite }: Props) {
	return (
		<AlertDialog open onOpenChange={(open) => !open && onCancel()}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Overwrite the existing setting?</AlertDialogTitle>
					<AlertDialogDescription>
						{name} already has a row for this segment, with value{" "}
						<q>
							<ValueText value={existing.value} enumOptions={enumOptions} masked={existing.isMasked} />
						</q>{" "}
						(revision {existing.revision}, updated {dateTimeOf(existing.updatedOn)}). Overwrite it with{" "}
						<q>
							<ValueText value={value} enumOptions={enumOptions} />
						</q>
						?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
					<AlertDialogAction onClick={onOverwrite}>Overwrite</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
